import { SharepointStatusType } from '~/enums/SharepointType';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { testIsAxiosError } from '~/redux/api/utils';
import { scribyl } from '~/services/serviceInstances';

export type SharepointConfigurationStatus = {
  tenantId: string;
  sharepointUrl: string;
  status?: SharepointStatusType;
  id?: string;
};

export async function getSharepointConfigurationStatus(): Promise<SharepointConfigurationStatus> {
  const defaultResponse: SharepointConfigurationStatus = {
    tenantId: '',
    sharepointUrl: '',
  };
  try {
    const response = await scribyl.get('/integration-config/validate');

    if (!response.data) {
      return {
        ...defaultResponse,
        status: SharepointStatusType.NotConnected,
      };
    }
    return response.data as SharepointConfigurationStatus;
  } catch (error) {
    if (testIsAxiosError<JsonApiErrorResponse>(error) && error.response) {
      return {
        ...defaultResponse,
        status: error.response.data.errors?.[0]?.detail as SharepointStatusType,
      };
    }
    throw error;
  }
}
